// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.house-admin {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  z-index: 50;
}
.house-admin__window {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  animation: ink-enter 0.16s ease-out;
  pointer-events: auto;
  width: 420px;
  max-width: 92%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  padding: 20px 22px 18px;
}
.house-admin__window * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .house-admin__window {
    animation: none;
  }
}
.house-admin__header {
  display: block;
  margin-bottom: 14px;
}
.house-admin__header-icon {
  display: none;
}
.house-admin__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 22px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
}
.house-admin__body {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1 1 auto;
  min-height: 0;
  padding-right: 4px;
}
.house-admin__body::-webkit-scrollbar {
  width: 6px;
}
.house-admin__body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.house-admin__label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
}
.house-admin__input, .house-admin__select {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  margin-bottom: 14px;
}
.house-admin__input:focus, .house-admin__select:focus {
  outline: none;
  border-color: var(--gold-main);
}
.house-admin__input::placeholder, .house-admin__select::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.house-admin__select option {
  background: #171b24;
  color: #ebe8e1;
}
.house-admin__toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #ebe8e1;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 14px;
  cursor: pointer;
  user-select: none;
}
.house-admin__toggle input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.house-admin__toggle-box {
  position: relative;
  width: 18px;
  height: 18px;
  flex: none;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.35);
  transition: border-color 0.12s ease;
}
.house-admin__toggle:hover .house-admin__toggle-box {
  border-color: var(--gold-dark);
}
input:focus-visible + .house-admin__toggle-box {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
input:checked + .house-admin__toggle-box {
  border-color: var(--gold-main);
}
input:checked + .house-admin__toggle-box::after {
  content: "";
  position: absolute;
  inset: 3px;
  border-radius: 2px;
  background: var(--gold-main);
}
.house-admin__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
  padding-top: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}
.house-admin__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.house-admin__button:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.house-admin__button:active:not(:disabled) {
  transform: translateY(1px);
}
.house-admin__button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.house-admin__button:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.house-admin__button:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}
.house-admin__button--secondary {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: rgba(255, 255, 255, 0.2);
}
.house-admin__button--secondary:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.house-admin__button--danger {
  color: #d9786d;
  background: transparent;
  border-color: rgba(217, 120, 109, 0.45);
}
.house-admin__button--danger:hover:not(:disabled) {
  background: rgba(217, 120, 109, 0.14);
  border-color: #d9786d;
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/components/HouseAdminConfig/HouseAdminConfig.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AANA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,yDDiBU;EChBV,WAAA;AAQF;AANE;EDiBA,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EAiIA,mCAAA;EC3JE,oBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAcJ;ADJE;EAAI,sBAAA;ACON;ADsIE;EChKA;IDgK0C,eAAA;EClI1C;AACF;AAnBE;EACE,cAAA;EACA,mBAAA;AAqBJ;AAjBE;EAAiB,aAAA;AAoBnB;AAlBE;EDoBA,kDA3BW;EA4BX,gBAAA;EACA,eCtB8B;EDuB9B,iBAAA;EACA,sBAAA;EACA,cAxCK;ACyCP;AAxBE;ED+HA,gBAAA;EACA,qBAAA;EACA,qDAAA;EC/HE,cAAA;EACA,aAAA;EACA,kBAAA;AA4BJ;ADmGE;EAAuB,UAAA;AChGzB;ADiGE;EAA6B,oCAAA;EAAsC,kBAAA;AC7FrE;AAhCE;EACE,cAAA;EACA,kBAAA;ED8BF,eAAA;EACA,gBAAA;EACA,cAzDO;AC8DT;AAjCE;EDsFA,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;EC3FE,mBAAA;AA0CJ;ADmDE;EAAU,aAAA;EAAe,8BAAA;AC/C3B;ADgDE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;ACzC1G;AAlDE;EACE,mBAAA;EACA,cDtCG;AC0FP;AAjDE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cD7CG;EC8CH,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAmDJ;AAjDI;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;AAmDN;AAhDI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,0CAAA;EACA,kBAAA;EACA,+BDrEM;ECsEN,mCAAA;AAkDN;AA/CI;EAAgB,8BAAA;AAkDpB;AAhDI;EAA8B,oCAAA;EAAsC,mBAAA;AAoDxE;AAlDI;EACE,8BAAA;AAoDN;AAlDM;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;AAoDR;AA/CE;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,+CAAA;AAiDJ;AA9CE;EDjCA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EASA,cAjFU;EAkFV,4BAAA;EACA,8BAAA;AC0EF;ADnFE;EAAyB,qCAAA;EAAuC,8BAAA;ACuFlE;ADtFE;EAA0B,0BAAA;ACyF5B;ADxFE;EAAa,YAAA;EAAc,mBAAA;AC4F7B;AD3FE;EAAkB,oCAAA;EAAsC,mBAAA;AC+F1D;ADvFE;EAAyB,6BAAA;EAA+B,+BAAA;AC2F1D;AAlFI;EACE,cDrGC;ECsGD,qCAAA;EACA,sCDxGQ;AC4Ld;AAlFM;EAAyB,cDzGxB;ECyG0C,qCAAA;EAAuC,8BAAA;AAuFxF;AApFI;EDbF,cA5FO;EA6FP,uBAAA;EACA,uCAAA;ACoGF;ADlGE;EAAyB,qCAAA;EAAuC,qBAhGzD;ACsMT","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","@use '../../theme/ink' as ink;\n\n// Centred form to put a house up for sale or for rent (and the admin fields).\n.house-admin {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  font-family: ink.$font-text;\n  z-index: 50;\n\n  &__window {\n    @include ink.panel;\n    @include ink.enter;\n    pointer-events: auto;\n    width: 420px;\n    max-width: 92%;\n    max-height: 90vh;\n    display: flex;\n    flex-direction: column;\n    padding: 20px 22px 18px;\n  }\n\n  &__header {\n    display: block;\n    margin-bottom: 14px;\n  }\n\n  // Decorative glyph, no longer displayed.\n  &__header-icon { display: none; }\n\n  &__title { @include ink.title(22px); }\n\n  &__body {\n    @include ink.scroll;\n    flex: 1 1 auto;\n    min-height: 0;\n    padding-right: 4px;\n  }\n\n  &__label {\n    display: block;\n    margin-bottom: 6px;\n    @include ink.label;\n  }\n\n  &__input,\n  &__select {\n    @include ink.field;\n    margin-bottom: 14px;\n  }\n\n  &__select option {\n    background: #171b24;\n    color: ink.$text;\n  }\n\n  &__toggle {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    color: ink.$text;\n    font-size: 14px;\n    font-weight: 600;\n    margin-bottom: 14px;\n    cursor: pointer;\n    user-select: none;\n\n    input {\n      position: absolute;\n      opacity: 0;\n      width: 0;\n      height: 0;\n    }\n\n    &-box {\n      position: relative;\n      width: 18px;\n      height: 18px;\n      flex: none;\n      border: 1px solid ink.$line-strong;\n      border-radius: 4px;\n      background: ink.$ink-field;\n      transition: border-color 0.12s ease;\n    }\n\n    &:hover &-box { border-color: var(--gold-dark); }\n\n    input:focus-visible + &-box { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n\n    input:checked + &-box {\n      border-color: var(--gold-main);\n\n      &::after {\n        content: '';\n        position: absolute;\n        inset: 3px;\n        border-radius: 2px;\n        background: var(--gold-main);\n      }\n    }\n  }\n\n  &__footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n    margin-top: 8px;\n    padding-top: 14px;\n    border-top: 1px solid ink.$line;\n  }\n\n  &__button {\n    @include ink.button;\n    @include ink.button-primary;\n\n    &--secondary {\n      color: ink.$text;\n      background: rgba(255, 255, 255, 0.07);\n      border-color: ink.$line-strong;\n\n      &:hover:not(:disabled) { color: ink.$text; background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n    }\n\n    &--danger {\n      @include ink.button-danger;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
